import React, { useContext, useState, useEffect } from "react";
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import AP3Dashboard from "area/ap3/AP3Dashboard";
import Appearance from "components/Pages/Appearance"
import LogiqMindManager from "components/Pages/LogiqMindManager";
import Accounting from "area/ap3/Accounting";
import Uploads from "area/ap3/Uploads";
import Files from "area/ap3/Files";

import Layout from "./Layout"

export default function AP3Routes() {
    let { path, url } = useRouteMatch();
  const { modalIsOpen,setModalIsOpen, companyId, setCompany,userInfo } = useContext(PrivateRoutesContext);

    useEffect(() => {
        document.title = "Align Admin FringeSecure | AP3";
    },[])

    return (
      <Layout >
        <Switch>
            <Route exact path={`${path}/`}>
                <Redirect to={`${path}/dashboard`} />
            </Route>
            <Route exact path={`${path}/dashboard`} component={AP3Dashboard} />
            <Route exact path={`${path}/appearance`} component={Appearance} />
            <Route exact path={`${path}/logiqmind-manager`} component={LogiqMindManager} />
            <Route exact path={`${path}/accounting`} component={Accounting} />
            <Route exact path={`${path}/uploads`} component={Uploads} />
            <Route exact path={`${path}/files`} component={Files} />
        </Switch>
      </Layout>
    )
}